/* eslint-disable no-mixed-operators */
/* eslint-disable no-useless-concat */
import React, { useEffect, useState } from "react";
import { read, utils, writeFile } from "xlsx";
import { useQuery } from "react-query";

import {
	getRegions,
	getMembers,
	getRegionalMembersByCode,
	getRegionalMembersByGender
} from "../../../api/apiServices";
import { useNavigate, useLocation } from "react-router-dom";
import Pagination from "../../../services/Pagination";
import toast, { Toaster } from "react-hot-toast";

const RegionalMembershipReports = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/regional_membership_report";

	const year = new Date().getFullYear() - 5;
	const years = Array.from(new Array(20), (val, index) => index + year);
	const curr = new Date();
	curr.setDate(curr.getDate());
	var date = curr.toISOString().substring(0, 10);

	const [isLoading, setIsLoading] = useState(false);
	const [regMembersFound, setRegMembersFound] = useState(false);
	const [regions, setRegions] = useState([]);
	const [region_code, setRegionCode] = useState("");

	const [searchData, setSearchData] = useState({
		allRegionalData: [],
		maleRegionalData: [],
		femaleRegionalData: [],
	});
	const [state, setState] = useState({
		isAll: true,
		isMale: false,
		isFemale: false,
	});

	useEffect(() => {
		getRegions().then((res) => setRegions(res));
	}, []);


	const [currentPage, setCurrentPage] = useState(1);
	const [postPerPage, setPostPerPage] = useState(25);


	let femaleData = [];
	let maleData = [];
	let allData = [];

	let allCount = 0;
	let maleCount = 0;
	let femaleCount = 0;


	let currentPosts = [];
	const indexOfLastPage = currentPage * postPerPage;
	const indexOfFirstPage = indexOfLastPage - postPerPage;

	const handleRegion = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		setRegionCode(value);
	};

	const handleSearch = async (e) => {
		e.preventDefault();
		await getRegionalMembersByCode(region_code.toLocaleUpperCase()).then((res) => {
			for (var k = 0; k < res?.length; k++) {
				allData.push({
					serial_no: k + 1,
					pf_number: res[k].pf_number,
					full_name:
						res[k].first_name +
						" " +
						res[k].middle_name +
						" " +
						res[k].last_name,
					region: res[k].region,
					gender: res[k].gender,
					date_joined: res[k].date_joined,
					profession: res[k].profession,
					current_employment: res[k].current_employment,
					mobile_number: res[k].mobile_number,
					email: res[k].email,
				});
			}
			setIsLoading(true)
			setRegMembersFound(true)
			setSearchData(prevData => ({
				...prevData,
				allRegionalData: res
			}))
			setState((prevData) => ({
				...prevData,
				isAll: true,
				isMale: false,
				isFemale: false,
			}));
		})
	};

	const handleAll = () => {
		const name = "All";
		setState((prevData) => ({
			...prevData,
			isAll: true,
			isMale: false,
			isFemale: false,
		}));
		handleExportExcel(name, allData);
	};

	const handleMale = async () => {
		setRegMembersFound(false)
		const name = "Male";

		const payLoad = {
			gender: "MALE",
			region_code: region_code
		}
		await getRegionalMembersByGender(payLoad).then((res) => {
			for (var k = 0; k < res?.length; k++) {
				maleData.push({
					serial_no: k + 1,
					pf_number: res[k].pf_number,
					full_name:
						res[k].first_name +
						" " +
						res[k].middle_name +
						" " +
						res[k].last_name,
					region: res[k].region,
					gender: res[k].gender,
					date_joined: res[k].date_joined,
					profession: res[k].profession,
					current_employment: res[k].current_employment,
					mobile_number: res[k].mobile_number,
					email: res[k].email,
				});
			}

			setIsLoading(true)
			setRegMembersFound(true)
			setState((prevData) => ({
				...prevData,
				isAll: false,
				isMale: true,
				isFemale: false,
			}));
			setSearchData(prevData => ({
				...prevData,
				maleRegionalData: res
			}))
			handleExportExcel(name, maleData);
		})
	};

	const handleFemale = async () => {
		setRegMembersFound(false)
		const name = "Female";
		const payLoad = {
			gender: "FEMALE",
			region_code: region_code
		}
		await getRegionalMembersByGender(payLoad).then((res) => {

			for (var k = 0; k < res?.length; k++) {
				femaleData.push({
					serial_no: k + 1,
					pf_number: res[k].pf_number,
					full_name:
						res[k].first_name +
						" " +
						res[k].middle_name +
						" " +
						res[k].last_name,
					region: res[k].region,
					gender: res[k].gender,
					date_joined: res[k].date_joined,
					profession: res[k].profession,
					current_employment: res[k].current_employment,
					mobile_number: res[k].mobile_number,
					email: res[k].email,
				});
			}

			setIsLoading(true)
			setRegMembersFound(true)
			setSearchData(prevData => ({
				...prevData,
				femaleRegionalData: res
			}))
			setState((prevData) => ({
				...prevData,
				isAll: false,
				isMale: false,
				isFemale: true,
			}));
			handleExportExcel(name, femaleData);
		})
	};

	const handleExportExcel = (name, data) => {
		console.log(name, data);
		const headings = [
			[
				"SERIAL NO.",
				"PF NUMBER",
				"FULL NAME",
				"REGION",
				"GENDER",
				"DATE JOINED",
				"PROFESSION",
				"CURRENT EMPLOYMENT",
				"MOBILE NUMBER",
				"EMAIL ADDRESS",
			],
		];

		const wb = utils.book_new();
		const ws = utils.json_to_sheet([]);
		utils.sheet_add_aoa(ws, headings);
		let filename = "";

		if (name === "Female") {
			filename = "Female_Reginal_Members.xlsx";
			utils.sheet_add_json(ws, data, {
				origin: "A2",
				skipHeader: true,
			});
		}
		if (name === "Male") {
			filename = "Male_Regional_Members.xlsx";
			utils.sheet_add_json(ws, data, {
				origin: "A2",
				skipHeader: true,
			});
		}
		if (name === "All") {
			filename = "All_Regional_Members.xlsx";
			utils.sheet_add_json(ws, data, {
				origin: "A2",
				skipHeader: true,
			});
		}
		utils.book_append_sheet(wb, ws, "Report");
		writeFile(wb, filename);
		navigate(from, { replace: true });
	}
	const handleCancel = () => {
		setState({
			isAll: true,
			isMale: false,
			isFemale: false,
		});
		navigate(from, { replace: true });
	};


	const searchRegionalMembers = (
		<>
			<form onSubmit={handleSearch}>
				<div className="form-group row">
					<label
						htmlFor="region_code"
						className="col-sm-2 label-text"
						style={{ color: "white" }}
					>
						Select Region<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<select
							type="text"
							id="region_code"
							autoComplete="off"
							style={{
								textTransform: "uppercase",
							}}
							onChange={handleRegion}
							value={state.region_code}
							required
							name="regionsRegionCode"
							className="form-control"
						>
							<option value=""></option>
							{regions?.map((reg, index) => (
								<option value={reg.region_code} key={index}>
									{reg.region} - {reg.region_code}
								</option>
							))}
						</select>
					</div>
					<div className="col-sm-2">
						<button
							type="submit"
							className="btn btn-success btn-block "
						>
							{" "}
							<i className="fa fa-search"></i> Search
						</button>
					</div>
				</div>
			</form>
		</>
	);

	if (state.isFemale) {
		currentPosts = searchData?.femaleRegionalData?.slice(indexOfFirstPage, indexOfLastPage);
	}
	if (state.isMale) {
		currentPosts = searchData?.maleRegionalData?.slice(indexOfFirstPage, indexOfLastPage);
	}
	if (state.isAll) {
		currentPosts = searchData?.allRegionalData?.slice(indexOfFirstPage, indexOfLastPage);
	}

	let content;
	content = (
		<div className="table-responsive lg table-wrapper">
			<table className="table table-bordered table-hover table-striped">
				<thead className="align">
					<tr>
						<th scope="col">#</th>
						<th scope="col">PF Number</th>
						<th scope="col">Full Name</th>
						<th scope="col">Region</th>
						<th scope="col">Gender</th>
						<th scope="col">Date Joined</th>
						<th scope="col">Profession</th>
						<th scope="col">Current Employment</th>
						<th scope="col">Mobile Number</th>
						<th scope="col">Email</th>
					</tr>
				</thead>
				<tbody>
					{currentPosts?.map((member, index) => (
						<tr key={member.id}>
							<td style={{ textAlign: "center" }}>
								{postPerPage * (currentPage - 1) +
									index +
									1}
							</td>
							<td>{member.pf_number}</td>
							<td style={{ whiteSpace: "nowrap" }}>
								{member.first_name +
									" " +
									member.middle_name +
									" " +
									member.last_name}
							</td>
							<td style={{ whiteSpace: "nowrap" }}>
								{member.region}
							</td>
							<td style={{ whiteSpace: "nowrap" }}>
								{member.gender}
							</td>
							<td style={{ whiteSpace: "nowrap" }}>
								{member.date_joined}
							</td>
							<td style={{ whiteSpace: "nowrap" }}>
								{member.profession}
							</td>
							<td style={{ whiteSpace: "nowrap" }}>
								{member.current_employment}
							</td>
							<td style={{ whiteSpace: "nowrap" }}>
								{member.mobile_number}
							</td>
							<td style={{ whiteSpace: "nowrap" }}>
								{member.email}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);


	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1>Regional Membership</h1>
			</section>
			<section className="content">
				<div className="box">

					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="panel-body">
										{searchRegionalMembers}
									</div>
								</div>
							</div>
							{regMembersFound && (
								<>
									<div className="panel-body">
										<div className="col-sm-4">
											<h4 className="panel-title">
												<button
													type="button"
													onClick={handleAll}
													className="btn btn-success btn-block"
												>
													<i
														className="fa fa-file-text"
														aria-hidden="true"
													></i>{" "}
													All Regional Members
												</button>
												&nbsp; &nbsp;
											</h4>
										</div>
										<div className="col-sm-4">
											<h4 className="panel-title">
												<button
													type="button"
													onClick={handleMale}
													className="btn btn-success btn-block"
												>
													<i
														className="fa fa-file-text"
														aria-hidden="true"
													></i>{" "}
													Male Regional Members
												</button>
												&nbsp; &nbsp;
											</h4>
										</div>
										<div className="col-sm-4">
											<h4 className="panel-title">
												<button
													type="button"
													onClick={handleFemale}
													className="btn btn-success btn-block"
												>
													<i
														className="fa fa-file-text"
														aria-hidden="true"
													></i>{" "}
													Female Regional Members
												</button>
												&nbsp; &nbsp;
											</h4>
										</div>
									</div>
									{content}
								</>
							)}

							<div className="panel-footer">
								{state.isAll && searchData?.allRegionalData?.length > 0 ? (
									<Pagination
										data={searchData?.allRegionalData}
										postPerPage={postPerPage}
										currentPage={currentPage}
										setCurrentPage={setCurrentPage}
										setPostPerPage={setPostPerPage}
									/>
								) : state.isMale && searchData?.maleRegionalData?.length > 0 ? (
									<>
										<Pagination
											data={searchData?.maleRegionalData}
											postPerPage={postPerPage}
											currentPage={currentPage}
											setCurrentPage={setCurrentPage}
											setPostPerPage={setPostPerPage}
										/>
										<div className="search-group">
											<button
												type="button"
												className="btn btn-danger "
												onClick={handleCancel}
											>
												{" "}
												<i className="fa fa-search"></i>{" "}
												Cancel
											</button>
										</div>
									</>
								) : state.isFemale &&
									searchData?.femaleRegionalData?.length > 0 ? (
									<>
										<Pagination
											data={searchData?.femaleRegionalData}
											postPerPage={postPerPage}
											currentPage={currentPage}
											setCurrentPage={setCurrentPage}
											setPostPerPage={setPostPerPage}
										/>
										<div className="search-group">
											<button
												type="button"
												className="btn btn-danger "
												onClick={handleCancel}
											>
												{" "}
												<i className="fa fa-search"></i>{" "}
												Cancel
											</button>
										</div>
									</>
								) : null}
							</div>
						</div>
					</div>
					{/* } */}
				</div>
			</section>
		</>
	);
};

export default RegionalMembershipReports;
